import { StrMeasureUnit } from "../common/enums";
import { HourBookingCategory } from "../workTime/hourBookingCategory";

export class DayBookingTypeItemBeta {
    id: string;
    name: string;
    number: number;
    allowEntryInDays: boolean;
    allowEntryInHours: boolean;
    dayHoursRatio: number;
    salaryRowTypeId: string;
    salaryRowTypeMeasureUnit: string;
    salaryRowTypeDecimals: number;
    salaryRowTypeKindCode: string;
    categories: HourBookingCategory[];
    calculateNormal: boolean;
    useWorkShiftCostCenter: boolean;
    useWorkShiftVehicle: boolean;

    constructor();
    constructor(obj: DayBookingTypeItemBeta);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.number = obj && obj.number || 0;
        this.allowEntryInDays = obj && obj.allowEntryInDays || true;
        this.allowEntryInHours = obj && obj.allowEntryInHours || true;
        this.dayHoursRatio = obj && obj.dayHoursRatio || 8;
        this.salaryRowTypeId = obj && obj.salaryRowTypeId || "";
        this.salaryRowTypeMeasureUnit = obj && obj.salaryRowTypeMeasureUnit || StrMeasureUnit.Day; // Default to day
        this.salaryRowTypeDecimals = obj && obj.salaryRowTypeDecimals || 0;
        this.salaryRowTypeKindCode = obj && obj.salaryRowTypeKindCode || "";
        this.categories = obj && obj.categories || [];
        this.calculateNormal = obj && obj.calculateNormal;
        this.useWorkShiftCostCenter = obj && obj.useWorkShiftCostCenter;
        this.useWorkShiftVehicle = obj && obj.useWorkShiftVehicle;
    }
}
